class ProductGallery extends HTMLElement {
  constructor() {
    super();

    this.gallery = this.querySelector(".product-gallery");
    var flkty = new Flickity(this.gallery, {
      // options
      cellAlign: "left",
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      watchCSS: true,
    });
  }
}

customElements.define("product-gallery", ProductGallery);
